import React, { useEffect, useState } from "react";

// const ImageComponent = ({
//   src,
//   alt = "image",
//   className,
//   onClick = () => {},
//   profile = true,
//   style = {},
// }) => {
//   const [imgSrc, setImgSrc] = useState(src);

//   useEffect(() => {
//     setImgSrc(src);
//   }, [src]);

//   const handleError = () => {
//     let errorImg = profile
//       ? require("../../assets/demoImg.png")
//       : require("../../assets/empty-image.png");
//     setImgSrc(errorImg);
//   };

//   return (
//     <img
//       src={imgSrc}
//       alt={alt}
//       className={className}
//       onClick={onClick}
//       onError={handleError}
//       style={{
//         width: "100%",
//         height: "100%",
//         objectFit: "cover",
//         // borderRadius:"65px",
//         ...style,
//       }}
//     />
//   );
// };

const ImageComponent = ({
  src,
  alt = "image",
  className,
  onClick = () => {},
  profile = true,
  style = {},
  variant = "grid", // 'grid' or 'lightbox'
}) => {
  const [imgSrc, setImgSrc] = useState(src);

  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  const handleError = () => {
    const errorImg = profile
      ? require("../../assets/demoImg.png")
      : require("../../assets/empty-image.png");
    setImgSrc(errorImg);
  };

  const getVariantStyles = () => {
    if (variant === "lightbox") {
      return {
        maxHeight: "400px",
        maxWidth: "400px",
        objectFit: "contain",
      };
    }
    return {
      aspectRatio: "1 / 1", // square look
      objectFit: "cover",
    };
  };

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      onClick={onClick}
      onError={handleError}
      style={{
        width: "100%",
        height: "100%",
        ...getVariantStyles(),
        ...style,
      }}
    />
  );
};

export default ImageComponent;
